import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'react-phone-number-input/style.css'
import App from './App'
import { Provider } from 'react-redux'
import store from './services/store/store'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { useMediaQuery } from '@mantine/hooks'

const root = ReactDOM.createRoot(document.getElementById('root'))
const COLOR_SCHEME_STORAGE_KEY = 'livehq-color-scheme'

const getStoredColorScheme = () => {
	if (typeof window === 'undefined') {
		return 'light'
	}

	try {
		const storedColorScheme = window.localStorage.getItem(
			COLOR_SCHEME_STORAGE_KEY,
		)
		return storedColorScheme === 'dark' ? 'dark' : 'light'
	} catch (error) {
		return 'light'
	}
}

const NotificationsHost = () => {
	const isSmallScreen = useMediaQuery('(max-width: 48em)')

	return (
		<Notifications
			position={isSmallScreen ? 'bottom-center' : 'bottom-right'}
		/>
	)
}

const AppRoot = () => {
	const [colorScheme, setColorScheme] = useState(getStoredColorScheme)

	useEffect(() => {
		try {
			window.localStorage.setItem(COLOR_SCHEME_STORAGE_KEY, colorScheme)
		} catch (error) {
			// Ignore storage write failures (private mode, disabled storage, etc.).
		}
	}, [colorScheme])

	const toggleColorScheme = () => {
		setColorScheme((currentColorScheme) =>
			currentColorScheme === 'dark' ? 'light' : 'dark',
		)
	}

	return (
		<MantineProvider
			withGlobalStyles
			withNormalizeCSS
			theme={{
				colorScheme,
				breakpoints: {
					xs: '36em',
					sm: '48em',
					md: '62em',
					lg: '75em',
					xl: '88em',
				},
			}}
		>
			<NotificationsHost />
			<Provider store={store}>
				<App colorScheme={colorScheme} toggleColorScheme={toggleColorScheme} />
			</Provider>
		</MantineProvider>
	)
}

root.render(<AppRoot />)
